import { AddToQueueOutlined } from '@mui/icons-material';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const loadStateFromLocalStorage = (): NoticiaListFiltro => {
  const savedState = localStorage.getItem('noticiaListFiltro');
  if (savedState) {
    try {
      // Tenta fazer o parse do JSON armazenado
      const parsedState: NoticiaListFiltro = JSON.parse(savedState);

      // Aqui você pode validar ou manipular os dados, se necessário
      return parsedState;
    } catch (error) {
      console.error('Erro ao ler o estado do localStorage:', error);
      // Retorna o valor inicial caso haja algum erro no parsing
      return ISNoticiaListFiltro;
    }
  }
  // Caso não haja dados no localStorage, define as datas de início e fim
  const currentYear = new Date().getFullYear();
  const dataInicial = `01/01/${currentYear-5}`;
  const dataFinal = `31/12/${currentYear}`;

  return {
    ...ISNoticiaListFiltro, // Espalha os valores padrão
    dataInicial,
    dataFinal
  };
};

// Função para gravar o estado no localStorage
export const saveStateToLocalStorage = (state: NoticiaListFiltro) => {
  try {
    // Convertendo as datas para string ISO antes de salvar

    // Converte o estado para uma string JSON e salva no localStorage
    localStorage.setItem('noticiaListFiltro', JSON.stringify(state));
  } catch (error) {
    console.error('Erro ao gravar no localStorage:', error);
  }
};

interface NoticiaListFiltro {
  dataInicial: string | null;
  dataFinal: string | null;
  search: string | '';
  apply: boolean;
}

const ISNoticiaListFiltro: NoticiaListFiltro = {
  dataInicial: null,
  dataFinal: null,
  search: '',
  apply: false
};

const noticiaPublicListFiltroSlice = createSlice({
  name: 'noticiaPublicListFiltro',
  initialState: loadStateFromLocalStorage,
  reducers: {
    atualizarNoticiaFiltro: (state, action: PayloadAction<NoticiaListFiltro>) => {
      state = action.payload;
    },
    // Ação para atualizarNoticia o campo dataInicial
    atualizarNoticiaDataInicial: (state, action: PayloadAction<string | null>) => {
      state.dataInicial = action.payload;
    },
    // Ação para atualizarNoticia o campo dataFinal
    atualizarNoticiaDataFinal: (state, action: PayloadAction<string | null>) => {
      state.dataFinal = action.payload;
    },
    atualizarNoticiaSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    atualizarNoticiaApply: state => {
      state.apply = !state.apply;
    },

    resetNoticia: () => ISNoticiaListFiltro,

    setNoticia: (state, action: PayloadAction<NoticiaListFiltro>) => {
      return { ...state, ...action.payload }; // Atualiza o estado com os dados recebidos
    },
    setStorageNoticia: state => {
      saveStateToLocalStorage(state);
    }
  }
});
// Exportando as ações (reducers)
export const {
  atualizarNoticiaFiltro,
  atualizarNoticiaDataInicial,
  atualizarNoticiaDataFinal,
  atualizarNoticiaSearch,
  resetNoticia,
  setNoticia,
  setStorageNoticia,
  atualizarNoticiaApply
} = noticiaPublicListFiltroSlice.actions;

export default noticiaPublicListFiltroSlice.reducer;
